export default "__VITE_ASSET__jjzSpINl__"